var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'transition',
    'flex',
    'flex-1',
    'flex-row',
    'items-center',
    'box-border',
    'relative',
    _vm.borderClasses,
    _vm.sizePreset === _vm.SizePreset.H32px && [
      'rounded-xl',
      'h-8',
      _vm.$slots.startAdornment ? 'ps-0' : 'ps-2',
      _vm.$slots.endAdornment ? 'pe-0' : 'pe-2',
    ],
    _vm.sizePreset === _vm.SizePreset.H40px && [
      'rounded-2xl',
      'h-10',
      _vm.$slots.startAdornment ? 'ps-0' : 'ps-4',
      _vm.$slots.endAdornment ? 'pe-0' : 'pe-3',
    ],
    'font-sans',
  ]},[_vm._t("startAdornment"),_vm._v(" "),_c('input',_vm._g(_vm._b({ref:"inputElement",class:[
      'oz-input',
      {
        '!input-autofill': _vm.darkMode === false,
        '!dark:input-autofill-dark': _vm.darkMode === true,
        '!input-autofill dark:!input-autofill-dark': _vm.darkMode === 'auto',
      },
      {
        '!placeholder-dark-text-300': _vm.darkMode === false,
        '!placeholder-light-text-300': _vm.darkMode === true,
        '!placeholder-dark-text-300 dark:!placeholder-light-text-300': _vm.darkMode === 'auto',
      },
      {
        'text-input-body-small': _vm.sizePreset === _vm.SizePreset.H32px,
        'text-body-posts': _vm.sizePreset === _vm.SizePreset.H40px,
      },
      {
        '!text-dark-text-100': _vm.darkMode === false,
        '!text-light-text-100': _vm.darkMode === true,
        '!text-dark-text-100 dark:!text-light-text-100': _vm.darkMode === 'auto',
      },
      _vm.hasExtraContent ? 'input-with-extra-content' : 'input-without-extra-content',
      _vm.disabled && {
        '!placeholder-dark-text-400': _vm.darkMode === false,
        '!placeholder-light-text-400': _vm.darkMode === true,
        '!placeholder-dark-text-400 dark:!placeholder-light-text-400': _vm.darkMode === 'auto',
      },
      _vm.disabled && 'pointer-events-none',
      {
        'text-left': _vm.textAlign === 'left',
        'text-right': _vm.textAlign === 'right',
        'text-center': _vm.textAlign === 'center',
      },
      _vm.type === 'datetime-local' && {
        'datetime-picker-auto': _vm.darkMode === 'auto',
        'datetime-picker-dark': _vm.darkMode === true,
        'datetime-picker-light': _vm.darkMode === false,
        // on iOS mobile, the datetime picker text is rendered in the center by default, and text-align property doesn't work on it.
        // so this is a hack to ensure that the input text is aligned based on the textAlign prop.
        'text-last-start': true,
      },
      _vm.shouldTruncateText && 'truncate',
    ],attrs:{"data-pw":_vm.testId,"data-cy":_vm.testId,"aria-invalid":_vm.xValidationMessage,"aria-errormessage":_vm.validationMessageId,"aria-describedby":_vm.validationMessageId,"type":_vm.type},domProps:{"value":_vm.inputValue}},'input',_vm.$attrs,false),{ ..._vm.$listeners, focusin: _vm.focusin, focusout: _vm.focusout, blur: _vm.blur, input: _vm.handleInput })),_vm._v(" "),_vm._t("endAdornment"),_vm._v(" "),_c('span',{class:[
      'absolute',
      'end-2',
      '-bottom-2',
      'transition',
      'text-12-16',
      'text-danger-100',
      'font-semibold',
      'truncate',
      'max-w-[calc(100%-1.5rem)]',
      'px-1',
      {
        'bg-light-ui-100': _vm.darkMode === false,
        'bg-dark-ui-100': _vm.darkMode === true,
        'bg-light-ui-100 dark:bg-dark-ui-100': _vm.darkMode === 'auto',
      },
    ],attrs:{"id":_vm.validationMessageId,"aria-live":"polite","data-cy":"validationMessage"}},[_vm._v(_vm._s(_vm.xValidationMessage ? _vm.validationMessage : null))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }